import React from "react";

import { ListItemText, ListItem, SxProps, Theme, Box } from "@mui/material";
import { format } from "date-fns";

import { Watering } from "api/types";

interface WateringsListItemProps {
  watering: Watering;
}

const addressStyles: SxProps<Theme> = {
  fontWeight: 500,
};

const dateStyles: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.text.secondary,
});

const WateringsListItem = React.forwardRef<any, WateringsListItemProps>(({ watering }, ref) => {
  const { tree, createdAt, id } = watering;

  return (
    <ListItem divider ref={ref} key={id}>
      <ListItemText
        primary={
          <Box component="span" sx={addressStyles}>
            {tree.address}
          </Box>
        }
        secondary={
          <Box component="span" sx={dateStyles}>
            {format(new Date(createdAt), "MM/dd/yyyy HH:mm")}
          </Box>
        }
      />
    </ListItem>
  );
});

WateringsListItem.displayName = "WateringsListItem";

export default WateringsListItem;
